export enum RecurringType {
  Time = 1,
  Video,
  Always,
}

export enum DisplayOn {
  AllVideos = 1,
  SelectedVideos = 2,
}

export enum TimingType {
  BeforeVideoStarts = 1,
  AfterVideoEnds = 2,
}

export enum ESegmentationBehavior {
  ApplyOnEverySegment,
  ApplyOnFirstSegment,
  ApplyOnLastSegment,
}

export enum FilterCondition {
  Or = 1,
  And,
  Not,
}

export enum ShowDuring {
  All = 1,
  Commercials,
  Videos,
}

export enum IndicateStatus {
  None,
  Loading,
  Success,
  Failed,
}

export enum ChannelPlatformType {
  Facebook = 1,
  Youtube,
  MyWebsite,
  MyApp,
  Custom,
}

export enum StreamingProtocol {
  Hls = 1,
  Push,
}

export enum AspectRatio {
  SixteenByNine = 1,
  FourByThree,
  OneByOne,
}

export enum DownloadSelection {
  OriginalFile = 1,
  Transcoded,
  Preview,
  PlayTranscodedGra,
  PlayTranscodedWasabi,
  PlayPreview,
  PlayTranscodedWasabiLondon,
  PlayTranscodedOracle,
  PlayTranscodedAlternate,
}

export enum ShowStateOnCalendar {
  Past = 1,
  Now,
  Future,
}

export enum TenantSettingsEnum {
  DeleteOriginalMediaFiles = "Delete original files",
  DoQcAnalyzeWhenUploading = "Perform QC analyze when uploading files",
  AllowRecordingFeature = "Recording Feature",
  TranscodeBypassFeatureEnabled = "Transcode Bypass Feature",
  ByPassWithGeneratingLowRes = "Bypass With Generating Low Res",
  UseMediaStartTimestampInScheduler = "Use Media Start Timestamp In Scheduler",
  FuturePreviewChannelsLimit = "Future Channels Limit",
  AvailabilityZoneForTranscoding = "Availability Zone For Transcoding",
  AvailabilityZoneForLiveFeedPreview = "Availability Zone For Live Feed Preview",
  LongShowColor = "Long Show Color",
  LongShowSeconds = "Long Show Seconds",
  NextShowSkipTags = "Next Show Skip Tags",
  ShowMediaLicenseSettings = 'Show "License" tab in media editor',
  ContentControlTranscodingProfile = "Transcoding Profile For Content Control",
  ContentControlTranscodingDestination = "Transcoding Destination For Content Control",
  ClippingStudioTranscodingDestination = "Transcoding Destination For Clipping Studio",
  ContentControlAIdetectionsSettings = "Content Control AI Detections Settings",
  DisplayContentControlStudioTimeInFrames = "Display Content Control Studio Time In Frames",
  FirstDayOfWorkWeek = "First Day Of Work Week",
  BroadcastsPreviewChannelStaticRendererSuffix = "Broadcasts Preview Channel Static Renderer Suffix",
  BroadcastsProgramChannelStaticRendererSuffix = "Broadcasts Program Channel Static Renderer Suffix",
}

export const RulesColors = [
  "#512da8",
  "#aa00ff",
  "#e57373",
  "#ffc400",
  "#00bfa5",
  "#1de9b6",
  "#40c4ff",
  "#448aff",
];

export const LibraryTypes = {
  Graphics: "graphics",
  Video: "video",
  Ads: "ads",
  Live: "live",
  Subs: "subs",
  //VideoRules: 'videoRules',
  AutopilotRules: "autopilotRules",
  DynamicPromo: "dynamicPromo",
  Layouts: "layouts",
  Blocks: "blocks",
  Broadcasts: "broadcasts",
};
